<script lang="ts" setup>
  import RulesPage, { type ScoringRow } from './RulesPage.vue';

  const scoringRows: ScoringRow[] = [
    { outcome: '🎯 correct song', score: '1000-600', tier: 1 },
    { outcome: '🤏 wrong song, correct artist', score: '300', tier: 2 },
    { outcome: '❌ wrong song, wrong artist', score: '0', tier: 3 },
    { outcome: '🚫 no guess', score: '0', tier: 3 },
  ];
</script>

<template>
  <RulesPage title="🎶 Guessing" scoring-label="Guesser scoring" :scoring-rows="scoringRows" :outcome-width="65">
    <p>After the choosing phase is over, the chosen song will start playing 🎵</p>
    <p>
      Your screen will also tell you when it is time to guess the song, but try to be quick! The quicker you guess
      correctly, the higher your score ⚡
    </p>
    <p>
      You guess a song via a text search, similar to how you would do it in the Spotify app. You can only submit your
      song guess once 🔎
    </p>
  </RulesPage>
</template>
